import { ConsentLocale, getConsentLocaleFromDocument } from '../utils/cookieConsentUtils';
import { useEffect, useState } from 'react';

/**
 * In our codebase, we use the term "opt-in" to describe the consent mechanism
 * for marketing emails. Specifically, we use this terminology because it aligns
 * with our standard practice for indicating user consent.
 *
 * For this particular checkbox, checking the box means the user is opting out
 * of marketing emails.
 *
 * In the context of the GDPR, a "soft opt-in" refers to a specific scenario
 * under which businesses can send marketing communications to individuals
 * without explicit prior consent.
 *
 * However by checking this box, the user is actively consenting to opt out
 * of marketing emails, reflecting their choice clearly in the interface
 */
export interface DataPrivacyParams {}

export interface DataPrivacyResults {
  showSoftOptInCheckbox: boolean;
}

export const SOFT_OPTIN_PROMPT =
  'I do not want to receive emails from Tock about features and products';

export const useDataPrivacy = (params?: DataPrivacyParams): DataPrivacyResults => {
  const [detectedLocation, setDetectedLocation] = useState<ConsentLocale | undefined>();
  useEffect(() => {
    const consentLocaleCookie = getConsentLocaleFromDocument();
    setDetectedLocation(consentLocaleCookie);
  }, []);
  const isInGDPRJurisdiction = detectedLocation === ConsentLocale.GDPR;

  return {
    showSoftOptInCheckbox: isInGDPRJurisdiction,
  };
};
